const map = {
	"./Accident2.png": "./src/assets/icons/Accident2.png",
	"./Declined.png": "./src/assets/icons/Declined.png",
	"./Defect.png": "./src/assets/icons/Defect.png",
	"./ENNORE.png": "./src/assets/icons/ENNORE.png",
	"./FILTER.png": "./src/assets/icons/FILTER.png",
	"./FS.png": "./src/assets/icons/FS.png",
	"./Heavyrain.png": "./src/assets/icons/Heavyrain.png",
	"./Horizantal_Nav_Top_Nomal Size_42x42.png": "./src/assets/icons/Horizantal_Nav_Top_Nomal Size_42x42.png",
	"./Horizantal_Nav_Top_onhover Size_62x62.png": "./src/assets/icons/Horizantal_Nav_Top_onhover Size_62x62.png",
	"./Indoasian 01.png": "./src/assets/icons/Indoasian 01.png",
	"./Indoasian.png": "./src/assets/icons/Indoasian.png",
	"./Kandla.png": "./src/assets/icons/Kandla.png",
	"./MBPT.png": "./src/assets/icons/MBPT.png",
	"./MSIL-G.png": "./src/assets/icons/MSIL-G.png",
	"./MSIL-M.png": "./src/assets/icons/MSIL-M.png",
	"./MSIL-SIL.png": "./src/assets/icons/MSIL-SIL.png",
	"./MUN.png": "./src/assets/icons/MUN.png",
	"./No warning.png": "./src/assets/icons/No warning.png",
	"./Numeric.png": "./src/assets/icons/Numeric.png",
	"./PIPAV.png": "./src/assets/icons/PIPAV.png",
	"./SEARCH.png": "./src/assets/icons/SEARCH.png",
	"./SIDE-NAV.png": "./src/assets/icons/SIDE-NAV.png",
	"./SMG.png": "./src/assets/icons/SMG.png",
	"./TKAP.png": "./src/assets/icons/TKAP.png",
	"./TKM.png": "./src/assets/icons/TKM.png",
	"./TKM3.png": "./src/assets/icons/TKM3.png",
	"./TOP-NAV.png": "./src/assets/icons/TOP-NAV.png",
	"./TVP-B.png": "./src/assets/icons/TVP-B.png",
	"./TVP-N.png": "./src/assets/icons/TVP-N.png",
	"./Team-invoice-pic-1.png": "./src/assets/icons/Team-invoice-pic-1.png",
	"./Team-invoice-pic-2.png": "./src/assets/icons/Team-invoice-pic-2.png",
	"./Team-invoice-pic-3.png": "./src/assets/icons/Team-invoice-pic-3.png",
	"./Team-invoice-pic-4.png": "./src/assets/icons/Team-invoice-pic-4.png",
	"./Team-invoice-pic-5.png": "./src/assets/icons/Team-invoice-pic-5.png",
	"./accident alert_16.jpeg": "./src/assets/icons/accident alert_16.jpeg",
	"./accident alert_24.jpeg": "./src/assets/icons/accident alert_24.jpeg",
	"./accident alert_32.jpeg": "./src/assets/icons/accident alert_32.jpeg",
	"./alert.png": "./src/assets/icons/alert.png",
	"./announcement.png": "./src/assets/icons/announcement.png",
	"./arrived.png": "./src/assets/icons/arrived.png",
	"./arrived_inactive.png": "./src/assets/icons/arrived_inactive.png",
	"./arrow_next.png": "./src/assets/icons/arrow_next.png",
	"./bar-chart.png": "./src/assets/icons/bar-chart.png",
	"./barrier.png": "./src/assets/icons/barrier.png",
	"./bg.svg": "./src/assets/icons/bg.svg",
	"./black-circle.png": "./src/assets/icons/black-circle.png",
	"./blue-dot-2.png": "./src/assets/icons/blue-dot-2.png",
	"./blue-dot.png": "./src/assets/icons/blue-dot.png",
	"./boat.png": "./src/assets/icons/boat.png",
	"./booked.png": "./src/assets/icons/booked.png",
	"./business.png": "./src/assets/icons/business.png",
	"./car-crash-1.png": "./src/assets/icons/car-crash-1.png",
	"./car-crash.png": "./src/assets/icons/car-crash.png",
	"./car.png": "./src/assets/icons/car.png",
	"./cf.png": "./src/assets/icons/cf.png",
	"./city.png": "./src/assets/icons/city.png",
	"./client-feedback.png": "./src/assets/icons/client-feedback.png",
	"./clock.png": "./src/assets/icons/clock.png",
	"./close.png": "./src/assets/icons/close.png",
	"./cloudy.png": "./src/assets/icons/cloudy.png",
	"./cold_wave.png": "./src/assets/icons/cold_wave.png",
	"./consent_approved.svg": "./src/assets/icons/consent_approved.svg?b06d",
	"./consent_pending.svg": "./src/assets/icons/consent_pending.svg?bc19",
	"./counter/all.svg": "./src/assets/icons/counter/all.svg",
	"./counter/diviations.svg": "./src/assets/icons/counter/diviations.svg",
	"./counter/nightdriving.svg": "./src/assets/icons/counter/nightdriving.svg",
	"./counter/overspeeding.svg": "./src/assets/icons/counter/overspeeding.svg",
	"./counter/stoppages.svg": "./src/assets/icons/counter/stoppages.svg",
	"./crane.png": "./src/assets/icons/crane.png",
	"./customer_pin.png": "./src/assets/icons/customer_pin.png",
	"./customer_pin_16.png": "./src/assets/icons/customer_pin_16.png",
	"./customer_pin_38.png": "./src/assets/icons/customer_pin_38.png",
	"./cyclone.png": "./src/assets/icons/cyclone.png",
	"./database.png": "./src/assets/icons/database.png",
	"./dedline-projects.png": "./src/assets/icons/dedline-projects.png",
	"./delivered.png": "./src/assets/icons/delivered.png",
	"./delivered_inactive.png": "./src/assets/icons/delivered_inactive.png",
	"./delivery.png": "./src/assets/icons/delivery.png",
	"./delivery_truck.png": "./src/assets/icons/delivery_truck.png",
	"./destination_icon.png": "./src/assets/icons/destination_icon.png",
	"./dispatch.png": "./src/assets/icons/dispatch.png",
	"./dispatch1.png": "./src/assets/icons/dispatch1.png",
	"./dot.png": "./src/assets/icons/dot.png",
	"./enmovil.png": "./src/assets/icons/enmovil.png",
	"./enmovil.svg": "./src/assets/icons/enmovil.svg?cf1f",
	"./files.png": "./src/assets/icons/files.png",
	"./filters.svg": "./src/assets/icons/filters.svg?9de4",
	"./funnel.png": "./src/assets/icons/funnel.png",
	"./gas-station.png": "./src/assets/icons/gas-station.png",
	"./gmarker.png": "./src/assets/icons/gmarker.png",
	"./googletruck.png": "./src/assets/icons/googletruck.png",
	"./green-dot.png": "./src/assets/icons/green-dot.png",
	"./green_arrow.png": "./src/assets/icons/green_arrow.png",
	"./hailstorm.png": "./src/assets/icons/hailstorm.png",
	"./heartbeat.png": "./src/assets/icons/heartbeat.png",
	"./heavywind.png": "./src/assets/icons/heavywind.png",
	"./home.png": "./src/assets/icons/home.png",
	"./icon_data_top_main-2.png": "./src/assets/icons/icon_data_top_main-2.png",
	"./icon_data_top_main-3.png": "./src/assets/icons/icon_data_top_main-3.png",
	"./icon_data_top_main-3.psd": "./src/assets/icons/icon_data_top_main-3.psd",
	"./icon_data_top_main-4.png": "./src/assets/icons/icon_data_top_main-4.png",
	"./icon_data_top_main.png": "./src/assets/icons/icon_data_top_main.png",
	"./info.png": "./src/assets/icons/info.png",
	"./invoice-data.png": "./src/assets/icons/invoice-data.png",
	"./kpi.png": "./src/assets/icons/kpi.png",
	"./legrand.png": "./src/assets/icons/legrand.png",
	"./loader.gif": "./src/assets/icons/loader.gif",
	"./loadingyard.png": "./src/assets/icons/loadingyard.png",
	"./location_data.svg": "./src/assets/icons/location_data.svg?09b3",
	"./logo.jpeg": "./src/assets/icons/logo.jpeg",
	"./logo.png": "./src/assets/icons/logo.png",
	"./logo.svg": "./src/assets/icons/logo.svg",
	"./mail_img1.png": "./src/assets/icons/mail_img1.png",
	"./marketing-strategy.png": "./src/assets/icons/marketing-strategy.png",
	"./maruti-logo-login.png": "./src/assets/icons/maruti-logo-login.png",
	"./maruti-logo.png": "./src/assets/icons/maruti-logo.png",
	"./mausam - cold day.png": "./src/assets/icons/mausam - cold day.png",
	"./mausam - cold wave.png": "./src/assets/icons/mausam - cold wave.png",
	"./mausam - dust raising winds.png": "./src/assets/icons/mausam - dust raising winds.png",
	"./mausam - dust storm.png": "./src/assets/icons/mausam - dust storm.png",
	"./mausam - fog.png": "./src/assets/icons/mausam - fog.png",
	"./mausam - ground froast.png": "./src/assets/icons/mausam - ground froast.png",
	"./mausam - hailstorm.png": "./src/assets/icons/mausam - hailstorm.png",
	"./mausam - heat wave.png": "./src/assets/icons/mausam - heat wave.png",
	"./mausam - heavy rain.png": "./src/assets/icons/mausam - heavy rain.png",
	"./mausam - heavy snow.png": "./src/assets/icons/mausam - heavy snow.png",
	"./mausam - hot day.png": "./src/assets/icons/mausam - hot day.png",
	"./mausam - strong surface winds.png": "./src/assets/icons/mausam - strong surface winds.png",
	"./mausam - thunderstorm.png": "./src/assets/icons/mausam - thunderstorm.png",
	"./mausam - warm night.png": "./src/assets/icons/mausam - warm night.png",
	"./media.png": "./src/assets/icons/media.png",
	"./menu-icon.png": "./src/assets/icons/menu-icon.png",
	"./menu-icon2.svg": "./src/assets/icons/menu-icon2.svg",
	"./nestle.png": "./src/assets/icons/nestle.png",
	"./nestleheader.svg": "./src/assets/icons/nestleheader.svg",
	"./new-logo.png": "./src/assets/icons/new-logo.png",
	"./nodefect.png": "./src/assets/icons/nodefect.png",
	"./optirun_v2.png": "./src/assets/icons/optirun_v2.png",
	"./out_for_delivery.png": "./src/assets/icons/out_for_delivery.png",
	"./out_for_delivery_inactive.png": "./src/assets/icons/out_for_delivery_inactive.png",
	"./paid.png": "./src/assets/icons/paid.png",
	"./pending.png": "./src/assets/icons/pending.png",
	"./performance.png": "./src/assets/icons/performance.png",
	"./poweredByEnmovil.svg": "./src/assets/icons/poweredByEnmovil.svg?ead9",
	"./red-dot.png": "./src/assets/icons/red-dot.png",
	"./red_arrow.png": "./src/assets/icons/red_arrow.png",
	"./refresh-icon.svg": "./src/assets/icons/refresh-icon.svg",
	"./sandstorm.png": "./src/assets/icons/sandstorm.png",
	"./search-icon.svg": "./src/assets/icons/search-icon.svg?7561",
	"./settings.png": "./src/assets/icons/settings.png",
	"./ship.png": "./src/assets/icons/ship.png",
	"./sidenav-blue.png": "./src/assets/icons/sidenav-blue.png",
	"./snowflake.png": "./src/assets/icons/snowflake.png",
	"./snowy.png": "./src/assets/icons/snowy.png",
	"./source_icon.png": "./src/assets/icons/source_icon.png",
	"./start_port.png": "./src/assets/icons/start_port.png",
	"./stats.png": "./src/assets/icons/stats.png",
	"./stop_marker.png": "./src/assets/icons/stop_marker.png",
	"./success_tick.png": "./src/assets/icons/success_tick.png",
	"./team-award.png": "./src/assets/icons/team-award.png",
	"./thunderstorm.png": "./src/assets/icons/thunderstorm.png",
	"./tolls-image.png": "./src/assets/icons/tolls-image.png",
	"./topnav-blue.png": "./src/assets/icons/topnav-blue.png",
	"./track_start.png": "./src/assets/icons/track_start.png",
	"./train-delay.png": "./src/assets/icons/train-delay.png",
	"./train-msil.png": "./src/assets/icons/train-msil.png",
	"./train-ontime-1.png": "./src/assets/icons/train-ontime-1.png",
	"./train-ontime.png": "./src/assets/icons/train-ontime.png",
	"./train.png": "./src/assets/icons/train.png",
	"./traindeliver.png": "./src/assets/icons/traindeliver.png",
	"./transit.png": "./src/assets/icons/transit.png",
	"./transit1.svg": "./src/assets/icons/transit1.svg",
	"./transit2.png": "./src/assets/icons/transit2.png",
	"./transit_inactive.png": "./src/assets/icons/transit_inactive.png",
	"./transportation.png": "./src/assets/icons/transportation.png",
	"./trending.png": "./src/assets/icons/trending.png",
	"./trip_created.svg": "./src/assets/icons/trip_created.svg",
	"./trip_deviation.png": "./src/assets/icons/trip_deviation.png",
	"./trip_deviation_red.png": "./src/assets/icons/trip_deviation_red.png",
	"./truck-end.png": "./src/assets/icons/truck-end.png",
	"./truck.png": "./src/assets/icons/truck.png",
	"./truck_1_24.png": "./src/assets/icons/truck_1_24.png",
	"./truck_1_32.png": "./src/assets/icons/truck_1_32.png",
	"./truck_2_24.png": "./src/assets/icons/truck_2_24.png",
	"./truck_2_32.png": "./src/assets/icons/truck_2_32.png",
	"./truck_3_24.png": "./src/assets/icons/truck_3_24.png",
	"./truck_3_32.png": "./src/assets/icons/truck_3_32.png",
	"./truck_4_24.png": "./src/assets/icons/truck_4_24.png",
	"./truck_4_32.png": "./src/assets/icons/truck_4_32.png",
	"./truck_5_24.png": "./src/assets/icons/truck_5_24.png",
	"./truck_5_32.png": "./src/assets/icons/truck_5_32.png",
	"./truck_6_24.png": "./src/assets/icons/truck_6_24.png",
	"./truck_6_32.png": "./src/assets/icons/truck_6_32.png",
	"./truck_7_24.png": "./src/assets/icons/truck_7_24.png",
	"./truck_7_32.png": "./src/assets/icons/truck_7_32.png",
	"./truck_atdealer_24.png": "./src/assets/icons/truck_atdealer_24.png",
	"./truck_atdealer_32.png": "./src/assets/icons/truck_atdealer_32.png",
	"./truck_atdelar.png": "./src/assets/icons/truck_atdelar.png",
	"./truck_dealer.png": "./src/assets/icons/truck_dealer.png",
	"./truck_empty_24.png": "./src/assets/icons/truck_empty_24.png",
	"./truck_empty_32.png": "./src/assets/icons/truck_empty_32.png",
	"./truck_emptyatplant.png": "./src/assets/icons/truck_emptyatplant.png",
	"./truck_going_24.png": "./src/assets/icons/truck_going_24.png",
	"./truck_going_32.png": "./src/assets/icons/truck_going_32.png",
	"./truck_inside.png": "./src/assets/icons/truck_inside.png",
	"./truck_inside_24.png": "./src/assets/icons/truck_inside_24.png",
	"./truck_inside_32.png": "./src/assets/icons/truck_inside_32.png",
	"./truck_leftdealer_24.png": "./src/assets/icons/truck_leftdealer_24.png",
	"./truck_leftdealer_32.png": "./src/assets/icons/truck_leftdealer_32.png",
	"./truck_na_24.png": "./src/assets/icons/truck_na_24.png",
	"./truck_na_32.png": "./src/assets/icons/truck_na_32.png",
	"./truck_null.png": "./src/assets/icons/truck_null.png",
	"./truck_outside_.png": "./src/assets/icons/truck_outside_.png",
	"./truck_overspeed.png": "./src/assets/icons/truck_overspeed.png",
	"./truck_return_24.png": "./src/assets/icons/truck_return_24.png",
	"./truck_return_32.png": "./src/assets/icons/truck_return_32.png",
	"./truck_returnplant.png": "./src/assets/icons/truck_returnplant.png",
	"./truckblue.png": "./src/assets/icons/truckblue.png",
	"./truckgreen.png": "./src/assets/icons/truckgreen.png",
	"./truckmsil.png": "./src/assets/icons/truckmsil.png",
	"./truckred.png": "./src/assets/icons/truckred.png",
	"./undelivered.svg": "./src/assets/icons/undelivered.svg",
	"./unloadingyard.png": "./src/assets/icons/unloadingyard.png",
	"./uploadicon.svg": "./src/assets/icons/uploadicon.svg",
	"./user-map.png": "./src/assets/icons/user-map.png",
	"./voltagewarning_16.jpeg": "./src/assets/icons/voltagewarning_16.jpeg",
	"./voltagewarning_24.jpeg": "./src/assets/icons/voltagewarning_24.jpeg",
	"./warning.png": "./src/assets/icons/warning.png",
	"./watch.png": "./src/assets/icons/watch.png",
	"./weather.png": "./src/assets/icons/weather.png",
	"./whtsapp_img.png": "./src/assets/icons/whtsapp_img.png",
	"./wind.png": "./src/assets/icons/wind.png",
	"./yellow-dot.png": "./src/assets/icons/yellow-dot.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";